import React from 'react';
import ReactDOM from 'react-dom';
import CareLabel from './components/CareLabel';
import './components/CareLabel.css';

// DOM yüklendikten sonra React uygulamasını başlat
document.addEventListener('DOMContentLoaded', function() {
    // Root elementini bul
    const container = document.getElementById('care-label-designer-root');

    if (container) {
        // Ürün ID'sini al
        const productId = container.getAttribute('data-product-id');

        // React uygulamasını render et
        ReactDOM.render(
            <CareLabel productId={productId} />,
            container
        );
    } else {
        console.error('Care Label Designer: Root element not found!');
    }
});